// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"ef2bd5b3","103":"5e72aa2c","171":"6b7e424a","274":"3e9f69ec","344":"19bcfd16","584":"10571d0d","601":"c436e861","797":"0c5a80a6","828":"ac27942a","906":"3234b320"}[chunkId] + ".chunk.js";
};